export default __webpack_public_path__ + "static/media/7S.fee8e36f.png";